import { create } from 'zustand';

export interface LightboxImage {
  url: string;
  previewUrl?: string;
  thumbnailUrl?: string;
  alt: string;
  fileName: string;
}

interface ImageLightboxState {
  isOpen: boolean;
  images: LightboxImage[];
  currentIndex: number;

  openLightbox: (images: LightboxImage[], startIndex?: number) => void;
  closeLightbox: () => void;
  goToIndex: (index: number) => void;
}

export const useImageLightboxStore = create<ImageLightboxState>()((set, get) => ({
  isOpen: false,
  images: [],
  currentIndex: 0,

  openLightbox: (images, startIndex = 0) =>
    set({ isOpen: true, images, currentIndex: startIndex }),

  closeLightbox: () =>
    set({ isOpen: false, images: [], currentIndex: 0 }),

  goToIndex: (index) => {
    const { images } = get();
    if (index >= 0 && index < images.length) {
      set({ currentIndex: index });
    }
  },
}));
